import './js/auth/authFireBase.js';
import './js/components/modal/openModalWindow.js';
import './js/features/trending-search-main/trending-search.js';
import './js/features/dark-mode';
import './js/components/modal/movie_modal';
import './js/features/scroll_to_top';
import './js/features/movie-search/search-by-keyword';
import './js/features/movie-search/search-by-year';
import './js/features/movie-search/search-by-genre';
import './js/features/movie-search/advanced-search';
import './js/components/modal/openModalWindow.js';
import './js/components/header/canvas-header.js';
